import { render, staticRenderFns } from "./projectResultNotice.vue?vue&type=template&id=0c58d3bc&scoped=true&"
import script from "./projectResultNotice.vue?vue&type=script&lang=js&"
export * from "./projectResultNotice.vue?vue&type=script&lang=js&"
import style0 from "./projectResultNotice.vue?vue&type=style&index=0&id=0c58d3bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58d3bc",
  null
  
)

export default component.exports